import React, { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { InteractionStatus } from "@azure/msal-browser";

function handleLogin(instance) {
  instance.loginRedirect(loginRequest).catch((error) => {
    console.error("login redirect failed", error);
  });
}

export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    setIsLoading(false);

    if (!isAuthenticated) {
      handleLogin(instance);
    }
  }, [inProgress, instance, isAuthenticated]);

  if (isLoading || inProgress !== InteractionStatus.None) {
    return (
      <div style={{ margin: "20px 0 0 10px", fontSize: "20px", fontStyle: "italic", fontWeight: "bold" }}>
        Authenticating...
      </div>
    );
  }

  return <>{props.children}</>;
};
